export default __webpack_public_path__ + "static/media/plastic-colored.929e3051.svg";